module.exports = __webpack_public_path__ + "media/images/shop/icon-education-fc4b202b206fb25d6f768433921e1b79.svg";